module.exports = __webpack_public_path__ + "img/reconocer_bg.ec771790.png";